import type { TestimonialCarouselItem } from './types';

/** Default copy for new rows in Builder (sub-field default). */
export const defaultReviewTextPlaceholder =
	'Share what stood out about working with the firm—communication, results, or support through your case.';

export const defaultTestimonialItems: TestimonialCarouselItem[] = [
	{
		reviewerName: 'Sheena J.',
		reviewTitle: 'They stuck with me through a long claim',
		reviewText:
			'After a car crash in LA, I needed counsel I could trust. I chose this team based on strong word of mouth, and they delivered. I was uninsured at the time, yet they still helped me access care, coordinated repairs on my vehicle, and pushed for a fair outcome. Injury cases rarely wrap up overnight; mine took patience, but they kept things moving and explained each step.',
	},
	{
		reviewerName: 'Ricky P.',
		reviewTitle: 'Patient with every follow-up question',
		reviewText:
			'I brought them a personal injury matter the carrier initially fought. From day one, the staff was straightforward and kind. I probably called more than I should have, and they still returned messages and walked me through options without rushing me off the phone. When you are stressed and hurt, that steadiness matters.',
	},
	{
		reviewerName: 'Tony A.',
		reviewTitle: 'Straight answers and real support',
		reviewText:
			'I had a lot of questions after a serious accident, and they took time to answer each one until I actually understood the plan. The front desk was easy to reach, and the medical partners they suggested were thorough. I ended up so confident in how they treat clients that I later referred business their way.',
	},
	{
		reviewerName: 'Maria L.',
		reviewTitle: 'Clear expectations from day one',
		reviewText:
			'I appreciated how plainly they explained timelines, paperwork, and what “winning” could look like for my situation. Nothing felt sugar-coated, and I always knew what the next milestone was. That kind of clarity lowered my stress more than I expected.',
	},
	{
		reviewerName: 'Jordan K.',
		reviewTitle: 'Fought when the insurer pushed back',
		reviewText:
			'My claim started out rocky—the other side was slow and skeptical. This group stayed organized, documented everything, and kept me in the loop when strategy shifted. Having people who will advocate when negotiations stall made a real difference for my family.',
	},
];
